<template>
  <footer class="footer">
    <description />
    <links />
  </footer>
</template>

<script>
import Description from './Description';
import Links from './Links';

export default {
  components: { Description, Links },
};
</script>

<style lang="scss" scoped>
.footer {
  margin-top: auto;
}
</style>
